const translations: any = {
    followers: 'lượt theo dõi',
    follower: 'lượt theo dõi',
    'Opening Jobs': 'Vị trí đang tuyển dụng',
    'About Us': 'Về chúng tôi',
    Video: 'Video',
    Benefits: 'Phúc lợi',
    Share: 'Chia sẻ',
    'View all jobs': 'Xem tất cả công việc',
    Address: 'Địa chỉ',
    Headquarter: 'Trụ sở chính',
    Size: 'Quy mô',
    Categories: 'Ngành nghề',
    Industry: 'Lĩnh vực',
    Contact: 'Liên hệ',
    'Read more': 'Xem thêm',
    'Show less': 'Thu gọn',
    'Company Video': 'Video Về Công Ty',
    'Company Benefits': 'Phúc Lợi Công Ty',
    'You are following': 'Đang theo dõi',
    Following: 'Đang theo dõi',
    Follow: 'Theo dõi',
    'There are currently no opening jobs.': 'Công ty hiện không tuyển dụng.',
    'There is no video for the moment.': 'Công ty chưa cập nhật video giới thiệu.',
    'The company has not defined the benefits yet.': 'Công ty chưa cập nhật thông tin về phúc lợi.',
    "You'll stop receive the newest jobs from this company.":
        'Bạn sẽ ngừng nhận thông báo về công việc mới nhất từ ​​công ty này.',
    Updated: 'Cập nhật',
    'Posted on': 'Đăng ngày',
    'You have': 'Bạn còn',
    'days to apply': 'ngày để ứng tuyển',
    'day to apply': 'ngày để ứng tuyển',
    Expire: 'Hết hạn',
    'TODAY!': 'HÔM NAY!',
    Posted: 'Đã đăng',
    'Expires: ': 'Hết hạn: ',
    in: 'trong',
    'Expires on today': 'Hết hạn trong hôm nay',
    day: 'ngày',
    'Up to': 'Lên đến',
    Bonus: 'Thưởng',
    'Healthcare Plan': 'Khám sức khỏe',
    'Paid Leave': 'Nghỉ phép',
    Training: 'Đào tạo',
    Awards: 'Giải thưởng',
    Library: 'Thư viện',
    Laptop: 'Laptop',
    Mobile: 'Điện thoại',
    'Travel Opportunities': 'Du lịch',
    'Team Activities': 'Hoạt động',
    Transportation: 'Trợ cấp đi lại',
    Canteen: 'Căn-tin',
    Vouchers: 'Thưởng quà',
    Kindergarten: 'Trông trẻ',
    Others: 'Khác',
    Map: 'Bản đồ',
    NEW: 'MỚI',
    staffs: 'nhân viên',
    job: 'việc làm',
    jobs: 'việc làm',
    'You should': 'Bạn phải',
    'Sign In': 'đăng nhập',
    'to save jobs': 'để lưu công việc',
    Applied: 'Đã Nộp Đơn',
    'Search for jobs hiring using our Job Search. Thousands of jobs in different field in Vietnam. Find your dream jobs and apply with just 1 click now!':
        'Thông tin tuyển dụng tất cả các việc làm trên toàn quốc với mức lương cao, hấp dẫn chế độ đãi ngộ tốt. Tìm kiếm nhanh việc làm tại website VietnamWorks!',
    'Yay! Thanks for following': 'Cảm ơn bạn đã theo dõi',
    Unfollowed: 'Đã bỏ theo dõi',
    Unfollow: 'Bỏ theo dõi',
    'You will receive the newest jobs from this company.':
        'Bạn sẽ nhận được thông báo về công việc mới nhất từ công ty này.',
    'You will not able to received notifications from this company.':
        'Bạn sẽ ngừng nhận thông tin việc làm từ công ty này.',
    'Unfollow company?': 'Bỏ theo dõi công ty?',
    'View more': 'Xem thêm',
    'Enter a job title': 'Nhập chức danh',
    'All locations': 'Tất cả địa điểm',
    'You have selected up to three locations': 'Bạn đã chọn tối đa ba địa điểm',
    '{companyName} latest recruitment {now} - VietnamWorks': '{companyName} tuyển dụng mới nhất {now} - VietnamWorks',
    '{companyName} is recruiting for many attractive positions on VietnamWorks with high salary and good benefits. See jobs at {companyName} and apply now!':
        '{companyName} đang tuyển dụng nhiều vị trí hấp dẫn trên VietnamWorks với mức lương cao, đãi ngộ tốt. Xem việc làm tại {companyName} và ứng tuyển ngay!',
    'Trusted company': 'Công ty uy tín',
    'Just removed 1 save job': 'Bạn vừa xóa 1 công việc',
    'You have saved job, view': 'Bạn đã lưu việc làm thành công, xem ',
    'My jobs': 'Việc làm của tôi',
    Success: 'Thành công',
    '/my-career-center/my-jobs?section=saved': '/quan-ly-nghe-nghiep/viec-lam-cua-toi?section=saved',
    'Jobs per page': 'Công việc mỗi trang',
    'Home page': 'Trang chủ',
    Jobs: 'Việc làm',
    'Job at': 'Việc làm tại',
    '/job-search': '/tim-viec-lam',
    'View map': 'Xem bản đồ'
}

export default translations
